import React, { Component, FunctionComponent } from 'react'
import LogsComponent from './LogsComponent'

export const PdLogs: FunctionComponent = () => {
    return <LogsComponent source='Pd' />
}